import { lensProxy } from '../../util/lens-proxy';
export var MfaStates = /*#__PURE__*/ function(MfaStates) {
    MfaStates["Enabled"] = "Enabled";
    MfaStates["Disabled"] = "Disabled";
    return MfaStates;
}({});
export var MfaTypes = /*#__PURE__*/ function(MfaTypes) {
    MfaTypes["SMS"] = "SMS";
    MfaTypes["Authenticator"] = "TOTP";
    return MfaTypes;
}({});
export var MfaFlows = /*#__PURE__*/ function(MfaFlows) {
    MfaFlows["Enable"] = "Enable";
    MfaFlows["Disable"] = "Disable";
    MfaFlows["Manage"] = "Manage";
    return MfaFlows;
}({});
export var mfaCodeVerificationLens = lensProxy();
